
<div class="ui-g ui-fluid clear-ui">
    <div class="ui-g-12">
        <h1 class="card__title--h1 color--white layout-page-title">Allocation Definition Import</h1>
    </div>
    <div class="ui-g-12">

        <div class="card">
            <div class="ui-g form-group">
                <div class="ui-g-12" style="padding-top: 0px">
                    <p>Allocation definitions are imported for each company separately. Check that you are currently in
                        correct company before uploading your data and starting the import process. Import logic rules:
                    </p>
                    <ol>
                        <li>If Allocation Definition is not found, it will be created</li>
                        <li>If Allocation Definition is found, but the Line (in selected year) is not, it will be
                            created</li>
                        <li>Otherwise an existing Line in existing Definition will be updated with the data from import
                        </li>
                       
                    </ol>
                    <p>
                        <button type="button" pButton icon="ui-icon-save" (click)="downloadTemplate()">Download sample Excel for Import</button>

                    </p>

                    <div class="ui-g">
                        <div *ngIf="importInProgress" pBlockUI class="full-page-overlay">
                            <p-progressSpinner>Loading</p-progressSpinner>
                        </div>
                    </div>
                    <div class="ui-g-12">
                        <p-tabView>
                            <p-tabPanel header="Allocation Factors Import Preview">
                                <div class="ui-g">

                                    <p-fileUpload [disabled]="importInProgress" name="excelFiles[]"
                                        chooseLabel="Select the allocation factors definition file..."
                                        [showUploadButton]="false" [showCancelButton]="false"
                                        (onSelect)="readExcel($event)" style="padding-bottom: 10px;"></p-fileUpload>
                                    <br />
                                    <div class="ui-g">
                                        <p style="padding-top: 10px; color: rgb(109, 109, 109);">{{ fileNameText }} {{
                                            guidText }}</p>
                                    </div>

                                    <ejs-grid id="GridData" [dataSource]="dataManager" [allowPaging]="true"
                                        [allowFiltering]="true" [pageSettings]="{ pageSize: 100}" [allowSorting]="true"
                                        [filterSettings]="filterOptions" [allowResizing]="true" height="400px"
                                        width="100%" (rowDataBound)="rowDataBound($event)" 
                                        (actionFailure)='actionFailure($event)'  [allowGrouping]='true' >
                                        <e-columns>
                                            <e-column field="AllocationItem" headerText="Allocation Item"
                                                textAlign="Left" width="250"></e-column>
                                            <e-column field="ReportRowNumber" headerText="Report Row Number"
                                                width="100"></e-column>
                                            <e-column field="ReportCode" headerText="Report Code"
                                                width="100"></e-column>
                                            <e-column field="SourceDimesion" headerText="Source Dimesion "
                                                width="150"></e-column>
                                            <e-column field="SourceDimensionCode" headerText="Source Dimension Code"
                                                width="100"></e-column>
                                            <e-column field="SourceDimensionValue" headerText="Source Dimension Value"
                                                width="200"></e-column>
                                            <e-column field="SourceDimensionValueCode"
                                                headerText="Source Dimension Value Code" width="100"></e-column>
                                            <e-column field="TargetDimension" headerText="Target Dimension"
                                                width="150"></e-column>
                                            <e-column field="TargetDimensionCode" headerText="Target Dimension Code"
                                                width="100"></e-column>
                                            <e-column field="TargetDimensionValue" headerText="Target Dimension Value"
                                                width="200"></e-column>
                                            <e-column field="TargetDimensionValueCode"
                                                headerText="Target Dimension Value Code" width="100"></e-column>
                                            <e-column field="Year" headerText="Year " width="100"
                                                textAlign="Center"></e-column>
                                            <e-column field="I" headerText="I " width="70"
                                                textAlign="Center"></e-column>
                                            <e-column field="II" headerText="II " width="70"
                                                textAlign="Center"></e-column>
                                            <e-column field="III" headerText="III " width="70"
                                                textAlign="Center"></e-column>
                                            <e-column field="IV" headerText="IV " width="70"
                                                textAlign="Center"></e-column>
                                            <e-column field="V" headerText="V " width="70"
                                                textAlign="Center"></e-column>
                                            <e-column field="VI" headerText="VI " width="70"
                                                textAlign="Center"></e-column>
                                            <e-column field="VII" headerText="VII " width="70"
                                                textAlign="Center"></e-column>
                                            <e-column field="VIII" headerText="VIII " width="70"
                                                textAlign="Center"></e-column>
                                            <e-column field="IX" headerText="IX " width="70"
                                                textAlign="Center"></e-column>
                                            <e-column field="X" headerText="X " width="70"
                                                textAlign="Center"></e-column>
                                            <e-column field="XI" headerText="XI " width="70"
                                                textAlign="Center"></e-column>
                                            <e-column field="XII" headerText="XII " width="70"
                                                textAlign="Center"></e-column>
                                            <e-column field="ImportedByUser" headerText="Imported by User "
                                                width="100"></e-column>
                                            <!--<e-column field="SessionGUID" headerText="Session GUID "
                                                width="150"></e-column>-->
                                            <e-column field="SystemDateTime" headerText="System Date Time " width="150"
                                                format='dd.MM.yyyy HH:mm:ss' type='dateTime'></e-column>
                                            <!--<e-column field="ImportStatusID" headerText="ImportStatusID "
                                                width="150"></e-column>-->
                                            <e-column field="ImportStatusDescription"
                                                headerText="Import Status Description " width="250"></e-column>
                                        </e-columns>
                                    </ejs-grid>
                                </div>
                            </p-tabPanel>
                            <p-tabPanel header="Error log">
                                <div class="ui-g">

                                    <ejs-grid id="GridError" [dataSource]="dataManagerError" [allowPaging]="true"
                                        [allowFiltering]="true" [pageSettings]="{ pageSize: 100}" [allowSorting]="true"
                                        [filterSettings]="filterOptions" [allowResizing]="true" height="400px"
                                        width="100%" >
                                        <e-columns>
                                            <e-column field="IDErrorLog" headerText="ID Error" textAlign="Left"
                                                width="100"></e-column>
                                            <!-- <e-column field="AllocationFactorsImportSessionGUID" headerText="Session GUID"
                                                width="150"></e-column>
                                                 <e-column field="ErrorTypeID" headerText="Error Type ID "
                                                width="150"></e-column>
                                           -->
                                            <e-column field="ErrorDescription" headerText="Error Description"
                                                width="400" textAlign="Left"></e-column>

                                        </e-columns>
                                    </ejs-grid>
                                </div>
                            </p-tabPanel>

                        </p-tabView>
                    </div>
                </div>

                <div class="ui-g">
                    <button type="button" label="Upload & Preview" [disabled]="!selectedFile" pButton
                        icon="ui-icon-save" class="ui-button-info" (click)="uploadFile()"></button>
                    <button type="button" label="Import" [disabled]="!readyForImport" pButton icon="ui-icon-save"
                        class="ui-button-info" (click)="importFile()"></button>
                    <button type="button" label="Cancel" [disabled]="!cancelEnabled" pButton icon="ui-icon-cancel"
                        class="ui-button-info" (click)="cancel()"></button>

                </div>


            </div>

        </div>
    </div>
</div>